import { render, staticRenderFns } from "./su1SurveyComponentTR.vue?vue&type=template&id=67a32786"
import script from "./su1SurveyComponentTR.vue?vue&type=script&lang=js"
export * from "./su1SurveyComponentTR.vue?vue&type=script&lang=js"
import style0 from "./su1SurveyComponentTR.vue?vue&type=style&index=0&id=67a32786&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports